import CookieConsentBanner from './CookieConsentBanner';

export default CookieConsentBanner;
